import { getConfigParams } from "@/lib/get-config-params"

import { useCustomSearchParams } from "."

/* Hook to get the configuration parameters from the URL */
const useConfigParams = () => {
  const [searchParams] = useCustomSearchParams()
  return getConfigParams(searchParams)
}

export { useConfigParams }
